"use client"

import React from 'react';
import { fabric } from 'fabric';

import Button from './Button';

import { Card, CardContent, CardDescription } from './ui/card';
import { Button as ShadcnButton } from './ui/button';
import __ from './../utils/translation';

const SelectionClipSettings = ({ canvas, activeSelection }) => {

  return (
    <Card className="border-0 shadow-none bg-background p-2">
      <CardContent className="p-0 space-y-4">
        <CardDescription className="text-sm text-muted-foreground leading-relaxed">
          {__('To apply clip path, select 2 objects and click the button below, the second object will be used as a mask for the first object.')}
        </CardDescription>
        
        <div id="clip-options" className="flex flex-col gap-2">
          <ShadcnButton 
            id="apply-clip-path" 
            variant="default" 
            className="w-full h-10 font-medium"
          >
            {__('Apply Clip Path')}
          </ShadcnButton>
          <ShadcnButton 
            id="remove-clip-path" 
            variant="outline" 
            className="w-full h-10 font-medium"
          >
            {__('Remove Clip Path')}
          </ShadcnButton>
        </div>
      </CardContent>
    </Card>
  )
}

export default SelectionClipSettings
